import React, { Component } from "react";
import ContractClaimForm from "./ContractClaimForm";
import SmallModal from "../../../../hoc/UI/SmallModal/SmallModal";
import { Button } from "rsuite";

class ContractClaim extends Component {
  state = {
    proj_contract_claim_id: null
  };

  componentDidMount() {
    this.props.contractClaim.fetch();
  }
  render() {
    let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <ContractClaimForm
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentContractClaim={
              this.state.proj_contract_claim_id === null
                ? null
                : this.props.contractClaim.contractClaim.find(
                    contractClaim =>
                      contractClaim.proj_contract_claim_id ===
                      this.state.proj_contract_claim_id
                  )
            }
            update={this.props.contractClaim.update}
            add={this.props.contractClaim.add}
            projectID={this.props.currentProjectID}
            disabled={this.props.disabled}
          />
        </SmallModal>
      );
    }
    return (
      <div>
        {this.props.disabled ? null : (
          <div style={{ textAlign: "right" }}>
            <Button
              color={"blue"}
              className={"my-2"}
              onClick={() => {
                this.setState({ proj_contract_claim_id: null });
                this.props.toggleSmallModalHandler();
              }}
            >
              Create New Contract Claim
            </Button>
          </div>
        )}
        {smallModal}

        <table className={"table"}>
          <thead>
            <tr>
              <th>Claim Name</th>
              <th>Claim Cost</th>
              {this.props.disabled ? null : <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {this.props.contractClaim.contractClaim.map(item => (
              <tr
                key={item.proj_contract_claim_id}
                onClick={e => {
                  if (e.target.type !== "button") {
                    this.setState({
                      proj_contract_claim_id: item.proj_contract_claim_id
                    });
                    this.props.toggleSmallModalHandler();
                  }
                }}
              >
                <td>{item.claim_name}</td>
                <td>{item.claim_cost}</td>
                {this.props.disabled ? null : (
                  <td>
                    <Button
                      color="blue"
                      type="button"
                      onClick={() => {
                        this.setState({
                          proj_contract_claim_id: item.proj_contract_claim_id
                        });
                        this.props.toggleSmallModalHandler();
                      }}
                    >
                      Edit
                    </Button>{" "}
                    <Button
                      color={"red"}
                      type="button"
                      onClick={() =>
                        this.props.contractClaim.delete(
                          item.proj_contract_claim_id,
                          this.props.currentProjectID
                        )
                      }
                    >
                      Delete
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ContractClaim;
